<div class="sl-wrap">

  <div class="sl-header">
    <div class="sl-header__info">
      <h2 class="sl-header__title">Publicaciones en redes sociales</h2>
      <p class="sl-header__sub">Gestiona y programa publicaciones en tus redes conectadas</p>
    </div>
    <div class="sl-header__actions">
      <button class="sl-btn sl-btn--outline" (click)="goToAccounts()">Mis cuentas</button>
      <button class="sl-btn sl-btn--primary" (click)="newPost()">+ Nueva publicación</button>
    </div>
  </div>

  <!-- FILTROS -->
  <div class="sl-filters">
  <select #networkSelect (change)="onNetworkChange(networkSelect.value)" class="sl-chip">
    <option value="">Todas las redes</option>
    <option value="TWITTER">Twitter</option>
    <option value="TIKTOK">TikTok</option>
    <option value="FACEBOOK">Facebook</option>
    <option value="INSTAGRAM">Instagram</option>
    <option value="LINKEDIN">LinkedIn</option>
    <option value="YOUTUBE">YouTube</option>
  </select>

<input type="date" class="sl-chip" #dateInput (change)="onDateChange(dateInput.value)">
    <button class="sl-chip" [class.sl-chip--active]="statusFilter === null" (click)="onFilterChange(null)">
      Todos ({{ totalElements }})
    </button>
    <button class="sl-chip" [class.sl-chip--active]="statusFilter === 'SCHEDULED'" (click)="onFilterChange('SCHEDULED')">
      Programados
    </button>
    <button class="sl-chip" [class.sl-chip--active]="statusFilter === 'PUBLISHED'" (click)="onFilterChange('PUBLISHED')">
      Publicados
    </button>
    <button class="sl-chip" [class.sl-chip--active]="statusFilter === 'FAILED'" (click)="onFilterChange('FAILED')">
      Fallidos
    </button>
    <button class="sl-chip" [class.sl-chip--active]="statusFilter === 'CANCELLED'" (click)="onFilterChange('CANCELLED')">
      Cancelados
    </button>
  </div>

  <!-- LOADING -->
  <div *ngIf="loading" class="sl-state sl-state--loading">
    <div class="sl-spinner"></div>
    <span>Cargando publicaciones...</span>
  </div>

  <!-- EMPTY -->
  <div *ngIf="!loading && posts.length === 0" class="sl-state sl-state--empty">
    <div class="sl-state__icon">📭</div>
    <p class="sl-state__text">No hay publicaciones{{ statusFilter ? ' con este filtro' : '' }}.</p>
    <button class="sl-btn sl-btn--primary" (click)="newPost()">Crear la primera</button>
  </div>

  <!-- TABLE -->
  <div *ngIf="!loading && posts.length > 0" class="sl-card">

    <table class="sl-table">

      <thead>
        <tr>
          <th>Contenido</th>
          <th>Redes</th>
          <th>Programado</th>
          <th>Estado</th>
          <th class="sl-table__actions-col">Acciones</th>
        </tr>
      </thead>

      <tbody>

        <!-- ===================== -->
        <!-- POST ROW -->
        <!-- ===================== -->
        <ng-container *ngFor="let post of posts">

          <tr class="sl-table__row" (click)="togglePost(post.postId)" style="cursor:pointer">

            <td class="sl-table__content">
              <span *ngIf="post.mediaType === 'IMAGE'" class="sl-media-badge sl-media-badge--image">🖼 Imagen</span>
              <span *ngIf="post.mediaType === 'VIDEO'" class="sl-media-badge sl-media-badge--video">🎬 Video</span>
              <div class="sl-preview-text">{{ getPreview(post.content) }}</div>
            </td>

            <td class="sl-table__networks">
              <span *ngFor="let target of post.targets"
                    class="sl-net-pill"
                    [class]="'sl-net-pill--' + target.network.toLowerCase() + ' sl-net-pill--st-' + target.status.toLowerCase()"
                    [title]="target.errorMessage || ''">

                <a *ngIf="target.externalUrl; else noLink"
                   [href]="target.externalUrl"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="sl-net-pill__link"
                   (click)="$event.stopPropagation()">

                  {{ networkLabels[target.network] }} ↗
                </a>

                <ng-template #noLink>
                  {{ networkLabels[target.network] }}
                </ng-template>

                <span *ngIf="target.status === 'FAILED'"
                      class="sl-retry"
                      (click)="retryTarget(target.targetId); $event.stopPropagation()">
                  ↻
                </span>

              </span>
            </td>

            <td class="sl-table__date">
              {{ post.scheduledAt | date:'dd/MM/yyyy HH:mm' }}
            </td>

            <td>
              <span class="sl-status" [class]="'sl-status--' + post.status.toLowerCase()">
                {{ getStatusLabel(post.status) }}
              </span>
            </td>

            <td class="sl-table__actions">
              <button class="sl-icon-btn sl-comment-btn" title="Comentarios" >
                💬

              <span  class="sl-comment-count">
                {{ post.comments }}
              </span>

            </button>
              <button *ngIf="canEdit(post)" class="sl-icon-btn" (click)="editPost(post); $event.stopPropagation()">✏️</button>
              <button *ngIf="canCancel(post)" class="sl-icon-btn" (click)="cancelPost(post); $event.stopPropagation()">⏸</button>
              <button *ngIf="canDelete(post)" class="sl-icon-btn sl-icon-btn--danger" (click)="deletePost(post); $event.stopPropagation()">🗑️</button>
            </td>

          </tr>

          <!-- ===================== -->
          <!-- COMMENTS (EXPANDABLE) -->
          <!-- ===================== -->
          <tr *ngIf="expandedPostId === post.postId">

            <td colspan="5" class="sl-comments-container">

              <div *ngIf="!post.commentList?.length" class="sl-empty-comments">
                Sin comentarios
              </div>

              <table *ngIf="post.commentList?.length" class="sl-table sl-table--comments">

                <tbody>

                  <ng-container *ngFor="let comment of post.commentList">

                    <!-- COMMENT -->
                    <tr class="comment-row">

                      <td class="col-msg" (click)="toggle(comment.externalId)" style="cursor:pointer">

                        {{ comment.message }}
                        <span>
                          {{ expandedComments.has(comment.externalId) ? '▼' : '▶' }}
                        </span>
                      </td>

                      <td class="col-net">
                        <span class="sl-net-pill sl-net-pill--{{ comment.network?.toLowerCase() }}">
                          {{ networkLabels[comment.network || ''] }}
                        </span>
                      </td>

                      <td class="col-user">
                        {{ comment.username || '-' }}
                      </td>

                      <td class="col-date">
                        {{ comment.createdAt | date:'dd/MM/yyyy HH:mm' }}
                      </td>

                      <td class="col-count">
                         <button class="sl-icon-btn sl-comment-btn" [class.has-replies]="(comment.replies?.length || 0) > 0" (click)="openReplyDialog(comment, $event)">
                            {{ expandedComments.has(comment.externalId) ? '📂' : '💬' }}
                          <span class="sl-comment-count">
                            {{ comment.replies?.length || 0 }}
                          </span>

                        </button>
                        <button class="sl-icon-btn sl-icon-btn--danger" title="Eliminar comentario"(click)="deleteComment(comment, $event)">

                            🗑️

                        </button>
                      </td>

                    </tr>

                    <!-- REPLIES -->
                    <tr *ngIf="expandedComments.has(comment.externalId)">

                      <td colspan="5" class="reply-box">

                        <div *ngIf="!comment.replies?.length">
                          Sin respuestas
                        </div>

                        <table class="reply-table">

                          <tr *ngFor="let reply of comment.replies" class="reply-row">

                            <td class="reply-msg">
                              ↳ {{ reply.message }}
                            </td>

                            <td class="reply-net">
                              <span class="sl-net-pill sl-net-pill--{{ reply.network?.toLowerCase() }}">
                                {{ networkLabels[reply.network || ''] }}
                              </span>
                            </td>

                            <td class="reply-user">
                              {{ reply.username }}
                            </td>

                            <td class="reply-date">
                              {{ reply.createdAt | date:'dd/MM/yyyy HH:mm' }}
                            </td>
                            <td class="reply-actions">

                              <button class="sl-icon-btn sl-icon-btn--danger" title="Eliminar respuesta"(click)="deleteComment(reply, $event)">

                                🗑️

                              </button>

                            </td>
                          </tr>

                        </table>

                      </td>

                    </tr>

                  </ng-container>

                </tbody>

              </table>

            </td>

          </tr>

        </ng-container>

      </tbody>

    </table>

  </div>

  <!-- PAGINATION -->
  <div *ngIf="!loading && totalPages > 1" class="sl-pagination">
    <button class="sl-btn sl-btn--outline" [disabled]="page === 0" (click)="prevPage()">‹ Anterior</button>
    <span class="sl-pagination__info">Página {{ page + 1 }} de {{ totalPages }}</span>
    <button class="sl-btn sl-btn--outline" [disabled]="page >= totalPages - 1" (click)="nextPage()">Siguiente ›</button>
  </div>

</div>